<template>
  <div @click="handleClick" v-html="icon" />
</template>

<script>
import { THEMES } from "@/config";
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      icons: {
        default: '<i class="fas fa-moon"></i>',
        dark: '<i class="fas fa-sun"></i>'
      }
    };
  },
  computed: {
    ...mapGetters(["theme"]),
    icon() {
      return this.icons[this.theme];
    }
  },
  methods: {
    ...mapMutations(["SET_THEME"]),
    handleClick() {
      const theme = this.theme == THEMES.DEFAULT ? THEMES.DARK : THEMES.DEFAULT;
      this.SET_THEME(theme);
    }
  }
};
</script>

<style>
</style>